import {useTranslation} from "next-i18next";
import React from "react";

interface MinimalCardProps {
	title: string;
	description: string;
	cost?: number;
	extraInformation?: string;
}

function MinimalCard({
	                     title,
	                     description,
	                     cost,
	                     extraInformation,
                     }: MinimalCardProps) {
	const {t} = useTranslation();
	return (
		<div className="shadow-md [&>*]:py-[10px] [&>*]:px-4 md:shadow-none md:border-b-2 md:pb-10 md:[&>*]:py-[0px] md:space-y-[10px] md:[&>*]:px-0 md:pt-2">
			<p className="bg-leo-button-gray text-white font-bold text-[16px] md:bg-white md:text-[20px] md:text-black">
				{title}
			</p>
			<p className="text-[16px] md:text-[18px]">{description}</p>
			{cost && (
				<div className="flex flex-row justify-between items-center text-leo-orange [&>*]:text-[16px] [&>*]:font-bold md:[&>*]:text-[18px]">
					<p className="">{t("components.minimalCard.cost")}</p>
					<p className="">{cost + " €"}</p>
				</div>
			)}
			{extraInformation && (
				<div className="flex flex-row justify-between items-center text-leo-divider-gray">
					<p className="text-[16px] md:text-[18px]">{extraInformation}</p>
				</div>
			)}
		</div>
	);
}

export default MinimalCard;
